import React from 'react';
import './Loader.css';

const spinner = (props) => {
    return (
        <div className="Loader">loading...</div>
    )
};

export default spinner;